import './section6.css';
import mapaOlimpia from '../../assets/mapaOlimpia/mapaolimpia.png';
import fotoLateral from '../../assets/mapaOlimpia/Localizacao.png'; 

const Section6 = () => {
  return (
    <section className="section6">
      <h1>Como Chegar</h1>

      <div className="section6-images">
  <div className="side-image-container">
  <img src={fotoLateral} alt="Foto lateral" className="side-image" />
</div>
        <a
          href="https://www.google.com.br/maps/place/Arena+Ol%C3%ADmpia+Shows+%26+Eventos/@-20.7358412,-48.9390642,13z/data=!4m6!3m5!1s0x94bc6f752476156f:0xcb287e1e890a4467!8m2!3d-20.7028266!4d-48.9178897!16s%2Fg%2F11y7b2kylg?hl=pt-BR&entry=ttu&g_ep=EgoyMDI1MDYxMC4xIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden-link-button"
        >
          <img src={mapaOlimpia} alt="Mapa Olímpia" className="map-image" />
        </a>       
      </div>
    </section>
  );
};

export default Section6;

